<dvl-visualization #visualization [data]="legend"></dvl-visualization>
